let baseUrl = "";
switch (MODE) {
  case "production":
    baseUrl = "https://opapi.shaobohealth.cn";
    break;
  case "test":
    baseUrl = "http://shaobo-opapi-test.qinghuo.link";
    break;
  case "local":
    baseUrl = "https://opapi.shaobohealth.cn";
    break;
}

export function get(url, params, successCallBack) {
  let loading = document.getElementById("loading");
  if (loading) {
    loading.classList.add("active");
  }
  let requestObj = {
    url: baseUrl + url,
    data: params,
    success: (res) => {
      successCallBack && successCallBack(res);
      if (loading) {
        loading.classList.remove("active");
      }
    },
    error: (e) => {
      console.log(e);
      if (loading) {
        loading.classList.remove("active");
      }
    },
  };
  $.get(requestObj);
}
export function post(url, params, successCallBack) {
  let loading = document.getElementById("loading");
  if (loading) {
    loading.classList.add("active");
  }
  let requestObj = {
    url,
    data: params,
    success: (res) => {
      successCallBack && successCallBack(res);
      if (loading) {
        loading.classList.remove("active");
      }
    },
    error: (e) => {
      console.log(e);
      if (loading) {
        loading.classList.remove("active");
      }
    },
  };
  $.post(requestObj);
}
